import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-swap-rtu-progress-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <div class="progress-content">
        <p>{{ data.message }}</p>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </mat-dialog-content>
  `,
  styles: [`
    .progress-content {
      padding: 20px;
      text-align: center;
    }
    mat-progress-bar {
      margin-top: 20px;
    }
  `]
})
export class SwapRtuProgressDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SwapRtuProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {}
} 